<h2 mat-dialog-title>Cambios sin guardar</h2>

<mat-dialog-content>
  <div class="unsaved-warning" role="alert">
    <mat-icon aria-hidden="true">warning</mat-icon>
    <p>
      Tienes cambios en el calendario que todavía no se han guardado. Si sales ahora, se perderán los eventos incompletos y cualquier cambio
      pendiente.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancelar</button>
  @if (data.can_save) {
    <button mat-stroked-button color="warn" type="button" (click)="discard()">Continuar sin guardar</button>
    <button mat-flat-button color="accent" type="button" (click)="save()">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  } @else {
    <button mat-flat-button color="accent" type="button" (click)="discard()">Continuar sin guardar</button>
  }
</mat-dialog-actions>
